import { Directive, HostListener, ElementRef, Renderer2, OnDestroy } from '@angular/core';

/**
 * Summary: Directive hack to force the numeric/chars toggle state of the standard text keyboard (iOS only)
 * Description: This class when instantiated as a directive forces the input field to type number with a step attr value of 0.01
 * a known hack for iOS to force the default text keyboard into its numeric toggle state.
 * We use focus and blur events with onDestroy hook to reset the keyboard when not shown.
 */
@Directive({
  selector: '[co-keyboard-numeric-chars]',
  providers: [
    { provide: Window, useValue: window }
  ]
})
export class CoKeyboardNumericCharsDirective implements OnDestroy {
  public isNative: boolean;
  constructor(
    private element: ElementRef,
    private renderer: Renderer2,
    public window: Window
  ) {
    this.isNative = this.window['cordova'] !== undefined && this.window['cordova'].platformId === 'ios';
    if (this.isNative) {
      this.renderer.setAttribute(this.element.nativeElement,'type', 'number');
      this.renderer.setAttribute(this.element.nativeElement,'step', '0.01');
    }
  }

  @HostListener('focus', ['$event'])
  onFocus(e) {
    if (this.isNative) {
      this.renderer.setAttribute(this.element.nativeElement,'type', 'text');
      this.renderer.removeAttribute(this.element.nativeElement,'step');
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(e) {
    if (this.isNative) {
      this.renderer.setAttribute(this.element.nativeElement,'type', 'number');
      this.renderer.setAttribute(this.element.nativeElement,'step', '0.01');
    }
  }

  ngOnDestroy() {
    if (this.isNative) {
      this.renderer.setAttribute(this.element.nativeElement,'type', 'number');
      this.renderer.setAttribute(this.element.nativeElement,'step', '0.01');
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/keyboard-numeric-chars/keyboard-numeric-chars.ts